import * as Yup from 'yup'

const validationObject = window.Sepia.ValidationSchema.donation
const sepia = window.Sepia.Validation

Yup.addMethod(Yup.mixed, 'sepiaValidate', function (name) {
  return this.test('sepiaValidate', '', function(value) {

    let validationArray = Object.entries(validationObject[name]).reverse()

    try {

      let error
      let validateFunction
      for (let i = 0; i < Object.keys(validationArray).length; i++) {
        validateFunction = sepia().rule(validationArray[i][0])(validationArray[i][1])
        error = validateFunction(value)

        if (error) {
          if (typeof error === 'string') {
            return this.createError({
              message: error
            })
          }
          if (typeof error === 'boolean') {
            return error
          }
        }
      }

    } catch (e) {
      return false
    }

  })
})

Yup.addMethod(Yup.mixed, 'sepiaValidatePhone', function () {
  return this.test('sepiaValidatePhone', '', function() {

    let value = document.getElementById('phone-number').value
    let country = document.getElementById('country').innerHTML
    let validateFunction, error

    try {

      if (!value) {
        return
      }

      if (country === 'United Kingdom') {
        validateFunction = sepia().rule('uk_phone', {})()
      } else {
        validateFunction = sepia().rule('int_phone', {})()
      }
      error = validateFunction(value)

      if (error) {
        if (typeof error === 'string') {
          return this.createError({
            message: error
          })
        }
        if (typeof error === 'boolean') {
          return error
        }
      }

    } catch (e) {
      return false
    }

  })
})

Yup.addMethod(Yup.mixed, 'sepiaValidatePostcode', function () {
  return this.test('sepiaValidatePostcode', '', function() {

    let value = document.getElementById('postcode').value
    let country = document.getElementById('country').innerHTML
    let validationArray = Object.entries(validationObject.postcode).reverse()

    try {

      let error
      let validateFunction
      for (let i = 0; i < Object.keys(validationArray).length; i++) {
        validateFunction = sepia().rule(validationArray[i][0])(validationArray[i][1])
        error = validateFunction(value)

        if (error) {
          if (typeof error === 'string') {
            return this.createError({
              message: error
            })
          }
          if (typeof error === 'boolean') {
            return error
          }
        }
      }

      if (country === 'United Kingdom') {
        validateFunction = sepia().rule('uk_postcode', {})()
        error = validateFunction(value)

        if (error) {
          if (typeof error === 'string') {
            return this.createError({
              message: error
            })
          }
          if (typeof error === 'boolean') {
            return error
          }
        }
      }

    } catch (e) {
      return false
    }

  })
})